module.exports = __webpack_public_path__ + "static/media/recharge-logo.68a10a25.png";